import {useEffect,useState,useLayoutEffect} from 'react'
import {Box,Typography,Button,Grid,IconButton,CircularProgress} from '@mui/material'
import Header from '../Components/Header'
import {useTheme,styled } from '@mui/material/styles'
import Dialog from '@mui/material/Dialog';
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import {useNavigate} from 'react-router-dom'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Snackbar from '@mui/material/Snackbar'
import Link from '@mui/material/Link';
import send_test from '../Redux/reducers/send_test';
import start_test from '../Redux/reducers/start_test';
import end_test from '../Redux/reducers/end_test';
import ItemView from '../Components/ItemView';
import QuestionView from '../Components/QuestionView';
import { ArrowBack } from '@mui/icons-material';
import BackCamera from '../Components/BackCamera'
import NoteDialog from '../Components/NoteDialog';
import { add_activities } from '../Redux/settingSlice';

const StartBox = styled(Box, {
})(({ theme}) => ({
	transition: theme.transitions.create('width', {
	easing: theme.transitions.easing.sharp,
	duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
	width: 7,
	backgroundColor: '#000000'
},
'&::-webkit-scrollbar-thumb': {
	backgroundColor: '#ffffff',
	borderRadius: 5
},
background:"#100101",
minHeight:300,
justifyContent:"flex-start",
alignItems:"center",
borderRadius:10,
minWidth:400,
maxWidth:"70%"
})
);

const ContainerBox = styled(Box, {
	})(({ theme}) => ({
		transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),
	overflowY: 'auto',
	overflowX: 'hidden',
	'&::-webkit-scrollbar': {
		width: 10,
		backgroundColor: '#000000'
	},
	'&::-webkit-scrollbar-thumb': {
		backgroundColor: '#ffffff',
		borderRadius: 10
	},
	minHeight:250,
	justifyContent:"flex-start",
	alignItems:"center",
	borderRadius:10,
	maxHeight:500
	})
);

const TryTest = ()=>{

	const [open,setOpen] = useState(false)
	const [isPaused,setIsPaused] = useState(true)
	const [message,setMessage] = useState('')
	const navigate = useNavigate()
	const theme = useTheme()
	const [count,setCount] = useState(0)
	const dispatch = useDispatch()
	const user = useSelector(state => state?.auth?.user);
	const [response,setResponse] = useState("")
	const [question,setQuestion] = useState({})
	const [hasStarted,setHasStarted] = useState(false)
	const [hasEnded,setHasEnded] = useState(false)
	const mode = useSelector(state => state?.theme?.mode);
	const [disqualify,setDisqualify] = useState(false)
	const [submitting,setSubmitting] = useState(false)
	const data = useSelector(state => state?.test.test);
	const [div,setDiv] = useState(parseInt((data?.time*60)/data?.questions))
	const [recent,setRecent] = useState(0)
	const [showModal,setShowModal] = useState(false)
	const [time,setTime] = useState(data?.time*60)
	const isAuth = true

async function handleEnd (){
	try{
		const test_data = {
			test:data,
			email:user?.email
		}
	
		await end_test(dispatch,test_data,user?.accessToken,setOpen,setMessage,setSubmitting,setHasStarted,setHasEnded,setIsPaused,setDiv,setTime)
	
	}catch(err){
		console.log(err)
	}
}

async function handleStart (){
	try{
		const test_data = {
			test:data,
			email:user?.email
		}
	
		await start_test(dispatch,test_data,user?.accessToken,setOpen,setMessage,setSubmitting,setHasStarted,setQuestion,setIsPaused,setDiv,setTime,addData)
	
	}catch(err){
		console.log(err)
	}
}
async function handleChat (){
	try{
	
		if (data?.questions > count) {
	
		const test_data = {
			test:data,
			message:response || "xxxxxxxxxxxxxxx",
			email:user?.email,
			index:count
		}
	
		await send_test(dispatch,test_data,user?.accessToken,setOpen,setMessage,setSubmitting,setQuestion,setResponse,setCount,setIsPaused,setDiv)
		
		} else {
	
		setIsPaused(true)
		setTime(0)
		setDiv(0)
		navigate("/dashboard/testInfo")
		setHasStarted(false)
		setCount(0)
		}
	}catch(err){
		console.log(err)
	}
}
		
async function sendChat(message){
	try{
	
		if (data?.questions > count) {
		
			const test_data = {
				test:data,
				message:message,
				email:user?.email,
				index:count
			}
		await send_test(dispatch,test_data,user?.accessToken,setOpen,setMessage,setSubmitting,setQuestion,setResponse,setCount,setIsPaused,setDiv)
		
		}else{
			setTime(0)
		}
	}catch(err){
		console.log(err)
	}
}

async function addData (newData){
	const getData = await localStorage.getItem("activities")

	if(getData){
		if (JSON.parse(getData).length === 4) {
			const updatedData = [...JSON.parse(getData).slice(1), newData]; 
			dispatch(add_activities(updatedData))
			localStorage.setItem("activities",JSON.stringify(updatedData))
		} else { 
			dispatch(add_activities([newData, ...JSON.parse(getData)]))
			localStorage.setItem("activities",JSON.stringify([newData, ...JSON.parse(getData)]))
		}
	}
}

useLayoutEffect(() => {
if (!isPaused) {
	if (time > 0) {
	const interval = setInterval(() => {
		if (time > 0) {
		setTime((prevTime) => prevTime - 1);
		if (div > 0) {
			setDiv((prevTime) => prevTime - 1);
		}else{
			setDiv(0)
			setIsPaused(true)
			sendChat("none")
		}
		}else{
			setTime(0);
			setIsPaused(true)
			setHasEnded(true)
		}
	}, 1000);

	return () => clearInterval(interval); 
	}
}
}, [time,div,isPaused]);

useEffect(()=>{
	console.log(data)
},[])

const formatTime = (seconds) => {
	const hours = Math.floor(seconds / 3600);
	const minutes = Math.floor((seconds % 3600) / 60);
	const remainingSeconds = seconds % 60;
return `${hours.toString().padStart(2, '0')}:${minutes
	.toString()
	.padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
}; 

	return(
	 <Grid container>
		<Grid item xs={12} sm={12} md={12} style={{height:70}}>
		</Grid>
		<Grid item xs={12} sm={12} md={12} style={{width:"80%",textAlign:"left"}}>
		{
			hasStarted ?
				<Box m={2} sx={{background:"#100101",minWidth:"60%",maxWidth:"80%",marginLeft:{sm:5,xs:5,md:17}}} display="flex" flexDirection="row" justifyContent="center" alignItems="flex-start">
					<BackCamera handleEnd={handleEnd} />
					<Box mt={2}>
						<Header>
							<Breadcrumbs aria-label="breadcrumb">
								<Typography sx={{fontSize:12,color:"gray"}}>Dashboard</Typography>
								<Typography sx={{fontSize:12,color:"gray"}}>Try Assessment</Typography>
							</Breadcrumbs>			
						</Header>
						<Snackbar 
							anchorOrigin={{
								vertical: 'top',
								horizontal: 'left',
							}} 
							message={message} 
							onClose={()=>{setOpen(false)}}
							open={open} 
							autoHideDuration={2000}
						/>
						<ContainerBox sx={{p:2}}>
							<Box ml={2}>
								<Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" width="80%">
									<Typography  mb={2} mt={2} ml={4} variant="h6" color="gold" fontWeight={500} sx={{fontFamily:"dinofans"}}>
										Take the assessment
									</Typography>	
									<IconButton onClick={(e)=>{
										e?.preventDefault()
										navigate("/testInfo")
									}}>
										<ArrowBack fontSize='small' sx={{color:"gold"}}/>
									</IconButton>					
								</Box>
								<QuestionView currentQuestion={count+1} totalQuestions={data?.questions} submitting={submitting} message={response} setMessage={setResponse} time={formatTime(time)} subTime={formatTime(div)} handleSend={handleChat} questions={data?.questions} count={count} content={question} title={data?.name} />
							</Box>		
						</ContainerBox>
					</Box>				
				</Box>
			:
				<StartBox sx={{marginLeft:{sm:5,xs:5,md:17},p:2}}>
					<Header>
						<Breadcrumbs aria-label="breadcrumb">
							<Typography color="text.primary" sx={{fontSize:12}}>Dashboard</Typography>
							<Typography color="text.primary" sx={{fontSize:12}}>Take Assessment</Typography>
						</Breadcrumbs>			
					</Header>
					<Snackbar 
						anchorOrigin={{
							vertical: 'top',
							horizontal: 'left',
						}} 
						message={message} 
						onClose={()=>{setOpen(false)}}
						open={open} 
						autoHideDuration={2000}
					/>
					{
					hasEnded ? 
						<Box ml={2}>
							<Typography  mb={2} mt={2} ml={4} variant="h6" color="gold" fontWeight={500} sx={{fontFamily:"dinofans"}}>
								Try the assessment
							</Typography>
							<ItemView title="Description" content="you have been disqualified to take the assessment because you you did not respect all policies and conditions and go over our warning limit"/>
							<Button onClick={ async (e)=>{
								e?.preventDefault()
								navigate("/testInfo")
							}} sx={{backgroundColor:"gold",color:"black",marginLeft:{xs:0,md:5},marginRight:{xs:0,md:5},fontSize:{xs:10,md:12},height:40,width:{xs:120,md:200},fontFamily:"dinofans"}} variant="contained">
								Close
							</Button>
						</Box>	
					:
						<Box ml={2}>
							<Typography  mb={2} mt={2} ml={4} variant="h6" color="gold" fontWeight={500} sx={{fontFamily:"dinofans"}}>
								Try the assessment
							</Typography>
							<Box display="flex" flexWrap="wrap" flexDirection="row" justifyContent="space-between" alignItems="center" sx={{width:{xs:"90%",md:"65%"}}}>
								<ItemView title="Title" content={data?.name}/>
								{/* <ItemView title="Candidates" content={`${data?.users?.length || 0} Candidates`}/> */}
							</Box>
							<ItemView title="Description" content={data?.description}/>
							<Box ml={5} sx={{display:"flex",flexDirection:{xs:"column",md:"row"},justifyContent:"space-evenly",width:{xs:"70%",md:"40%"},alignItems:"flex-start",marginBottom:3}}>
								<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
									<IconButton>
										<CalendarMonthIcon style={{color:"gray"}}/>
									</IconButton>
									<Typography color="white" fontSize={14} width={80}>
										{data?.start_date}
									</Typography>
								</Box>
								<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
									<IconButton>
										<CalendarMonthIcon style={{color:"gray"}}/>
									</IconButton>
									<Typography color="white" fontSize={14} width={50}>
										{data?.start_moment}
									</Typography>
								</Box>
								<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
									<IconButton>
										<CalendarMonthIcon style={{color:"gray"}}/>
									</IconButton>
									<Typography color="white" fontSize={14} width={80}>
										{data?.time} min
									</Typography>
								</Box>
							</Box>
							<Button onClick={ async (e)=>{
								e?.preventDefault()
								setShowModal(true)
							}} sx={{backgroundColor:"gold",color:"black",marginLeft:{xs:0,md:5},marginRight:{xs:0,md:5},fontSize:{xs:10,md:12},height:40,width:{xs:120,md:200},fontFamily:"dinofans"}} variant="contained">
								{
									submitting ? 
										<CircularProgress size={20} sx={{color:"black"}}/>
									:
									"Start test"
								}
							</Button>
						</Box>	
							
					}	
				</StartBox>
				}
			<NoteDialog setVisible={setShowModal} visible={showModal} handleClick={handleStart}/>
		</Grid>
		<Grid item xs={12} sm={12} md={12} style={{height:40}}>
		</Grid>
	 </Grid>

	)

	}

	export default TryTest